import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Whenever the route path changes, instantly snap to the top left corner (0,0)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component is completely invisible!
}